
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/income/bank-income",
      function () {
        return require("private-next-pages/docs/income/bank-income.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/income/bank-income"])
      });
    }
  